import { validateInputs } from 'shared/lib';
import { IPointListDto } from 'shared/api/business/interfaces/point-list-dto.interface';
import { SignUpErrors } from 'shared/consts';

interface IValidateForm {
  fio: string;
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;
  selectedPoints: IPointListDto[];
}

export const validateCreateEmployeeForm = ({
  fio,
  email,
  phone,
  password,
  confirmPassword,
  selectedPoints,
}: IValidateForm) => {
  if (!validateInputs.validateFullName(fio)) {
    return SignUpErrors.INCORRECT_FULL_NAME;
  }
  if (!validateInputs.validateMail(email)) {
    return SignUpErrors.INCORRECT_EMAIL;
  }
  if (!validateInputs.validatePhone(phone)) {
    return SignUpErrors.INCORRECT_PHONE;
  }
  if (!validateInputs.validatePassword(password)) {
    return SignUpErrors.INCORRECT_PASSWORD;
  }
  if (!validateInputs.validateConfirmPassword(password, confirmPassword)) {
    return SignUpErrors.PASSWORDS_NOT_MATCH;
  }
  if (selectedPoints.length < 1) {
    return SignUpErrors.SELECT_POINTS;
  }

  return false;
};
